import React, { useState } from 'react';
import styles from './AboutSection.module.css';
import ModalForm from '../ModalForm/ModalForm';
import { FaPlane, FaGlobe, FaShieldAlt, FaHeart } from 'react-icons/fa';
import AboutImage from '../../data/Images/aboutimage.jpg'

const AboutUsSection = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <section id="about-section" className={styles.aboutSection}>
      <h2 className={styles.aboutTitle}>ABOUT US</h2>
      <h3 className={styles.aboutSubtitle}>
        Leading Online Flight Booking Platform | Best Airfare Deals Worldwide
      </h3>
      <p className={styles.aboutDescription}>
       Trusted by millions of travelers worldwide. Flight Reservation Hub offers the best flight deals, secure booking, and award-winning customer service for all your travel needs.
      </p>

      <div className={styles.aboutContent}>
        <div className={styles.aboutImage}>
          <img src={AboutImage} alt="About Flight Reservation Hub" className={styles.aboutImageImg} />
        </div>

        <div className={styles.aboutText}>
          <h4 className={styles.highlightTitle}>YOUR RELIABLE ONLINE TRAVEL BOOKING PARTNER SINCE 2020</h4>
          <p className={styles.aboutTextParagraph}>
            <strong>Flight Reservation Hub</strong> is a leading online travel agency specializing in affordable flights, vacation packages, and business travel solutions. With partnerships across 500+ airlines globally, we provide competitive airfares, instant booking confirmation, and comprehensive travel insurance options for domestic and international destinations.
          </p>
          <p className={styles.aboutTextParagraph}>
            <strong>Our expertise includes:</strong> budget flight searches, multi-city itineraries, group bookings, corporate travel management, and last-minute flight deals with transparent pricing and no hidden fees.
          </p>
          <p className={styles.aboutTextParagraph}>
            Join over 2 million satisfied customers who trust us for their travel planning needs. Experience hassle-free booking with our user-friendly platform and dedicated support team.
          </p>

          <button className={styles.aboutContactBtn} onClick={openModal}>✈️ Plan Your Journey</button>

          <div className={styles.aboutIcons}>
            <div className={styles.aboutIconItem}><strong><FaPlane /> SEAMLESS BOOKING</strong></div>
            <div className={styles.aboutIconItem}><strong><FaGlobe /> GLOBAL DESTINATIONS</strong></div>
            <div className={styles.aboutIconItem}><strong><FaShieldAlt /> SECURE PAYMENTS</strong></div>
            <div className={styles.aboutIconItem}><strong><FaHeart /> CUSTOMER SATISFACTION</strong></div>
          </div>

          <ModalForm isOpen={modalOpen} closeModal={closeModal} />
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
